import { serialize, CookieSerializeOptions, parse } from 'cookie'
import type { NextApiResponse } from 'next'

/**
 * This sets `cookie` using the `res` object
 */

export const setCookie = (res: NextApiResponse, name: string, value: unknown, options: CookieSerializeOptions = {}) => {
  // Objects/arrays (and null: typeof null === 'object') must use JSON.stringify —
  // String(obj) yields '[object Object]'
  const stringValue = typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' ? String(value) : 'j:' + JSON.stringify(value)

  if (typeof options.maxAge === 'number') {
    options.expires = new Date(Date.now() + options.maxAge * 1000)
  }

  res.setHeader('Set-Cookie', serialize(name, stringValue, options))
}

export const getCookie = (cookie: any) => {
  return parse(cookie || '')
}
